import { Signal } from '@angular/core';

import { Observable } from 'rxjs';

import { ChurnReason, SubscriptionEndDateI } from '@core/churn-flow-types';

export abstract class ChurnFlowDataBaseService {
  // Intro page - we should display the end date for subscription and last date to cancel (it depends on a billing period / commitment period)
  public abstract subscriptionCancellationDates: Signal<SubscriptionEndDateI | undefined>;

  // Too expensive - we should hide downsell solution if company is on plan Start.
  public abstract displayDownsellSolution: Signal<boolean | undefined>;

  // Subscription loss - we need to get CareersSite URL
  public abstract careersSiteUrl: Signal<string | undefined>;

  // All-in-one, Not hiring - Activate Tellent HR free trial should close the overlay and open dialog on TAC/OneSettings dashboard.
  public abstract activateTellentHrFreeTrial(): void;

  // Return locked churn reason if exists.
  public abstract lockedChurnReason: Observable<ChurnReason | undefined>;

  // Subscription loss - we should cancel subscription.
  public abstract cancelSubscription(): Observable<{ success: boolean }>;

  // Lock selected churn reason.
  public abstract lockInChurnReason(reason: ChurnReason): Observable<ChurnReason>;

  // Farewell page - check if cancelled subscription has contract terms that will renew the subscription one more time.
  public abstract willSubscriptionRenewOnce: Signal<boolean | undefined>;
}
